'use strict';
angular
    .module('TR')
    .directive('priceToken', function () {
        return {
            restrict: 'E',
            replace: true,
            template: '<span class="price" ng-transclude></span>',
            transclude: true
        };
    });
